import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
// utils
import localStorageAvailable from '@/utils/localStorageAvailable';
// components
import { useSettingsContext } from '@/components/settings';
//
import { allLangs, defaultLang } from '@/locales/config-lang';
import { ensureLanguage } from '@/locales/i18n';

// ----------------------------------------------------------------------

export default function useLocales() {
  const { i18n, t: translate } = useTranslation();

  const { onChangeDirectionByLang } = useSettingsContext();

  const storageAvailable = localStorageAvailable();

  const langStorage = storageAvailable
    ? localStorage.getItem('i18nextLng')
    : '';

  const currentLang = useMemo(
    () => allLangs.find(_lang => _lang.value === langStorage) || defaultLang,
    [langStorage],
  );

  const handleChangeLanguage = useCallback(
    async newlang => {
      // Load the target language's bundle before switching so the UI
      // doesn't briefly render raw keys (translations are code-split).
      await ensureLanguage(newlang);
      i18n.changeLanguage(newlang);
      onChangeDirectionByLang(newlang);
    },
    [i18n, onChangeDirectionByLang],
  );

  return useMemo(
    () => ({
      onChangeLang: handleChangeLanguage,
      translate: (text, options) => translate(text, options),
      currentLang,
      allLangs,
    }),
    [handleChangeLanguage, translate, currentLang],
  );
}
